import styled from 'styled-components/macro'
import { Box } from '@alobato/flex-box'

export default styled(Box)`
  background-color: ${props => props.theme.colors.white};
  border: 1px solid #e8edf4;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.05);
`





